export default {
  icons: {
    compass: require('./icons/compass.png'),
    glfrBusinessLogo: require('./icons/glfr_business_logo.png')
  }
}
